import { Injectable, EventEmitter } from '@angular/core';
import { firstValueFrom, Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '@services/logging.service';
import { Router } from '@angular/router';
import { LicensingCountry } from '@models/licensingCountry.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private apiBuildVersionNumber: string = null;
  private _jsonURL = 'assets/assemblyInfo.json';
  public navExpanded = true;

  public apiBuildVersionNumber$ = new ReplaySubject<string>(1);
  public isGridExtended: EventEmitter<boolean> = new EventEmitter();
  public gridExpanded = false;

  userCountry: LicensingCountry;
  constructor(
    private http: HttpClient,
    private logger: LoggingService,
    private router: Router,
  ) {}

  public getJSON(): Observable<any> {
    if (window.location.host.endsWith('localhost:63758')) {
      return this.http.get(this._jsonURL);
    } else {
      return this.http.get('assemblyInfo.json');
    }
  }

  public async GetAPIBuildVersion(): Promise<string> {
    this.apiBuildVersionNumber = <string>await firstValueFrom(this.http.get(`/api/Navigation/GetAPIBuildVersion`, { responseType: 'text' })).catch(
      (e) => {
        this.logger.httpError(this.constructor.name, 'GetComments', e);
        if (e.status === 401) {
          this.router.navigate(['nostudyaccess']);
        }
      },
    );

    this.apiBuildVersionNumber$.next(this.apiBuildVersionNumber);
    return this.apiBuildVersionNumber;
  }
}
